import { cn } from '@/lib/cn';

const Parabola04Icon = ({ className }: { className?: string }) => {
  return (
    <div className={cn('stroke-[1.8px]', className)}>
      <div className={className}>
        <svg
          fill="none"
          width={'1em'}
          height={'1em'}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 17C18 9.6002 16.9706 2 12 2C7.02944 2 6 9.6002 3 17"
            stroke="currentColor"
            strokeLinecap="round"
          />
          <path
            d="M3 20H4.05882M15.7059 20H16.7647M19.9412 20H21M7.23529 20H8.29412"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.59961 9.8999C11.1356 8.81133 11.4716 8.3999 11.9996 8.3999M11.9996 8.3999C12.5276 8.3999 12.8636 8.81133 14.3996 9.8999M11.9996 8.3999V20.3999"
            stroke="currentColor"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default Parabola04Icon;
